import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  imports: [],
  selector: 'lx-price-lists-portal-more-info-title',
  templateUrl: './more-info-title.component.html',
  styleUrls: ['./more-info-title.component.scss', './print-more-info-title.component.scss'],
})
export class MoreInfoTitleComponent {
  @Input() title!: string;
}
